export default __webpack_public_path__ + "static/media/Stroke_placement-18.2ebe3d54.png";